/**
 * @format
 */
import { Grid, Paper, Typography, Box } from '@mui/material';

function ActivationCard({ activation, handleActivation }) {
  const { activationName, description, activationPoints } = activation;
  return (
    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
      <Paper
        onClick={() => handleActivation(activation)}
        sx={{
          p: { xs: 2, sm: 3 },
          minHeight: { xs: 'auto', sm: 260 },
          bgcolor: 'white',
          color: 'black',
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          cursor: 'pointer',
          '&:hover': {
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.7)',
          },
        }}
      >
        <Typography sx={{ fontWeight: 800, fontSize: 15, mb: 2 }}>
          {activationName}
        </Typography>
        <Box
          component="ul"
          sx={{
            p: 0,
            m: 0,
            pl: 2,
            flexGrow: 1,
            '& li': { mb: 1, fontSize: 13, lineHeight: 1.4 },
          }}
        >
          {activationPoints.map((point, i) => (
            <li key={i}>{point.replace(/["\\]/g, '')}</li>
          ))}
        </Box>
        {description && (
          <Typography
            sx={{
              mt: 2,
              fontSize: 12,
              color: 'rgba(0,0,0,0.5)',
              fontStyle: 'italic',
              lineHeight: 1.4,
            }}
          >
            {description}
          </Typography>
        )}
      </Paper>
    </Grid>
  );
}

export default ActivationCard;
